import { createContext, useContext, type ReactNode } from "react";

/** Flag-key → assigned variant, as returned by the amplitude-experiments service. */
export type ExperimentVariants = Record<string, string>;

// Client-safe: holds only the already-resolved variant map (the server did the
// fetch). Defaults to empty so a view rendered without a provider reads "control".
const ExperimentsContext = createContext<ExperimentVariants>({});

export function ExperimentsProvider({ variants, children }: { variants: ExperimentVariants; children: ReactNode }) {
	return <ExperimentsContext.Provider value={variants}>{children}</ExperimentsContext.Provider>;
}

/**
 * Read the assigned variant for an experiment flag key, or `undefined` when the flag
 * is unassigned/off (no experiment configured, or the visitor isn't bucketed).
 */
export function useExperiment(flagKey: string): string | undefined {
	return useContext(ExperimentsContext)[flagKey];
}
